import React, { useContext } from 'react';
import NavbarDropdown from './NavbarDropdown';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DataContext from 'y4/context/DataContext';
import _ from 'lodash';

const NavbarTopDropDownMenus = () => {
  const { globalData } = useContext(DataContext);
  const routes = globalData.menu ?? [];
  const menus = routes.filter((r, i) => {
    if (i === 0) return false;
    return !_.isEmpty(r.children);
  });

  return (
    <>
      {menus.map((r_1, i_1) => {
        return r_1.children.map((r_2, i_2) => {
          return (
            <NavbarDropdown title={r_2.name} key={`${i_1}_${i_2}`}>
              {r_2.children.map((r_3, i_3) => {
                return (
                  <Dropdown.Item
                    key={`${i_1}_${i_2}_${i_3}`}
                    as={Link}
                    className={r_3.active ? 'link-600' : 'text-500'}
                    to={r_3.to}
                  >
                    {r_3.name}
                  </Dropdown.Item>
                );
              })}
            </NavbarDropdown>
          );
        });
      })}
    </>
  );
};

export default NavbarTopDropDownMenus;
